export default "__VITE_ASSET__Cns7h2oq__"